var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhiteNavyGrayBgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
    fill: "#454A67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08787 5.08787C5.20503 4.97071 5.39497 4.97071 5.51213 5.08787L8 7.57574L10.4879 5.08787C10.605 4.97071 10.795 4.97071 10.9121 5.08787C11.0293 5.20503 11.0293 5.39497 10.9121 5.51213L8.42426 8L10.9121 10.4879C11.0293 10.605 11.0293 10.795 10.9121 10.9121C10.795 11.0293 10.605 11.0293 10.4879 10.9121L8 8.42426L5.51213 10.9121C5.39497 11.0293 5.20503 11.0293 5.08787 10.9121C4.97071 10.795 4.97071 10.605 5.08787 10.4879L7.57574 8L5.08787 5.51213C4.97071 5.39497 4.97071 5.20503 5.08787 5.08787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhiteNavyGrayBgRounded);
export default __webpack_public_path__ + "static/media/closeWhiteNavyGrayBgRounded.384b036b39bc19912fddffa31785b8e5.svg";
export { ForwardRef as ReactComponent };